import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';

/**
 * Dati per la modale di visualizzazione descrizione completa
 */
export interface MovementManagerDescriptionDialogData {
  /** Codice articolo (mostrato come titolo) */
  code: string;
  /** Descrizione completa dell'articolo */
  description: string;
}

/**
 * Modale semplificata per visualizzare la descrizione completa di un articolo
 * Layout minimalista: solo titolo (codice), descrizione e pulsante chiudi
 */
@Component({
  selector: 'app-movement-manager-description-dialog',
  templateUrl: './movement-manager-description-dialog.component.html',
  styleUrls: ['./movement-manager-description-dialog.component.scss']
})
export class MovementManagerDescriptionDialogComponent {

  constructor(
    public dialogRef: MatLegacyDialogRef<MovementManagerDescriptionDialogComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: MovementManagerDescriptionDialogData
  ) {}

  /**
   * Chiude la modale
   */
  onClose(): void {
    this.dialogRef.close();
  }

}
